
import {COLOR_appbar_background_default, COLOR_drawer_background, COLOR_expansionPanelHeader} from "./colors";

export const overrides = {

        MuiAppBar: {
            colorPrimary: {
                backgroundColor: COLOR_appbar_background_default + ' !important'
            },
        },

        MuiDrawer: {
            paper: {
                backgroundColor:  COLOR_drawer_background + ' !important'
            }
        },
        MuiExpansionPanelSummary: {
            root: {
                backgroundColor: COLOR_expansionPanelHeader + ' !important'
            }
        },

        MuiButton: { // Nome do componente ⚛️ / folha de estilo
            text: { // Nome da regra
          //      color: 'orange', // Um pouco de CSS
            },
        },
}

